// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".cls-1{stroke-width:3px}.cls-1,.cls-2,.cls-3{stroke-miterlimit:10}.cls-1,.cls-3{fill:none;stroke:#fff}.cls-4{fill:#fff}.cls-2{fill:#ffc122;stroke:#000}.cls-2-ok{fill:#00ff29;stroke:#000}", ""]);
// Exports
module.exports = exports;
